module.exports = __webpack_public_path__ + "img/color_gris.85394d25.svg";